import './product-detail.scss';
import Swiper from 'swiper/bundle';
class ProductDetail {
    constructor (element) {
        this.$product = element;
        this.$productAddtoCart = this.$product.querySelector('[data-product-detail="add-to-cart"]');
        this.$productActionbar = this.$product.querySelector('[data-product-detail="actionbar"]');
        this.$pageFooter = document.querySelector('[data-footer]');
        this.$pageScroller = document.querySelector('[data-scroll-button="root"]');
    }

    initialize () {
        this.initGallerySlider();
        this.setEvents();

        // init check states
        this.isFooterVisible(this.$pageFooter);
        this.isAddToCartVisible(this.$productAddtoCart);
    }

    setEvents () {
        window.addEventListener('scroll', () => {
            this.isFooterVisible(this.$pageFooter);
            this.isAddToCartVisible(this.$productAddtoCart);
        });
    }

    // load slider
    initGallerySlider () {
        const mainGallerySlider = new Swiper('.product-detail__gallery-slider', {
            slidesPerView: 1,
            centeredSlides: true,
            loop: true,
            loopedSlides: 3
        });

        const thumbnailGallerySlider = new Swiper('.product-detail__gallery-thumbs', {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 4,
            loop: true,
            slideToClickedSlide: true
        });

        mainGallerySlider.controller.control = thumbnailGallerySlider;
        thumbnailGallerySlider.controller.control = mainGallerySlider;
    }

    isFooterVisible (footer) {
        if (!footer) {
            return false;
        }

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.$productAddtoCart.classList.add('product-detail__product-add--is-hidden');
                    this.$pageScroller.classList.add('product-detail__product-add--is-hidden');
                } else {
                    this.$productAddtoCart.classList.remove('product-detail__product-add--is-hidden');
                    this.$pageScroller.classList.remove('product-detail__product-add--is-hidden');
                }
            });
        });

        observer.observe(footer);
    }

    isAddToCartVisible (addto) {
        if (!addto) {
            return false;
        }

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.$productActionbar.classList.remove('product-detail__actionbar--is-visible');
                } else {
                    this.$productActionbar.classList.add('product-detail__actionbar--is-visible');
                }
            });
        });

        observer.observe(addto);
    }
}

export { ProductDetail };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productDetail = $context.querySelectorAll('[data-product-detail="root"]');

        for (let i = 0; i < $productDetail.length; i++) {
            const productDetail = new ProductDetail($productDetail[i]);
            productDetail.initialize();
        }
    }
});
